"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagIcon = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var tag_icon_style_1 = require("./tag.icon.style");
(0, theme_1.addStyles)(tag_icon_style_1.Style);
exports.TagIcon = {
    view: function (tag, summary, color) {
        var value = summary != null ? summary.revisions.length : null;
        return (0, mithril_1.m)('div', {
            className: tag_icon_style_1.CSS.container,
            style: {
                'border-color': core_shared_1.ColorHash.hash(tag.objectId),
                'background-color': color ? color : '#FFFFFF'
            }
        }, value);
    }
};
//# sourceMappingURL=tag.icon.js.map